import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Testimonials() {
  return (
    <section className="section">
      <div className="container testi-grid">
        <Reveal>
          <span className="eyebrow">Cerita Mereka</span>
          <h2 className="h2">
            Rumah bersih,
            <br />
            <em>mood pun pulih.</em>
          </h2>
          <div className="rating-row">
            <span className="stars">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={17} fill="currentColor" />
              ))}
            </span>
            <strong>4.9/5</strong>
            <small>Rating pelanggan antarcleaning</small>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <blockquote className="quote">
            <span className="quote-mark">“</span>
            <p>
              Sejak pakai antarcleaning, saya jadi punya lebih banyak waktu untuk keluarga. Petugasnya ramah, detail, dan hasilnya benar-benar
              kinclong. Recommended banget!
            </p>
            <footer>
              <span className="t-avatar">NS</span>
              <span>
                <strong>Nadia S.</strong>
                <small>Pelanggan Reguler, Jakarta</small>
              </span>
            </footer>
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
}
